import axios from "axios";

const TERMINAL_TOUR_STATUSES = new Set(["completed", "skipped"]);

export const normalizeTourProgress = (value = {}) => ({
  tourKey: String(value?.tourKey || value?.tour_key || "").trim(),
  tourVersion: String(value?.tourVersion || value?.tour_version || "").trim(),
  status: String(value?.status || "not_started").trim().toLowerCase(),
  currentStepKey: value?.currentStepKey || value?.current_step_key || null,
  startedAt: value?.startedAt || value?.started_at || null,
  completedAt: value?.completedAt || value?.completed_at || null,
  updatedAt: value?.updatedAt || value?.updated_at || null,
});

export const isTerminalTourProgress = (progress) =>
  TERMINAL_TOUR_STATUSES.has(String(progress?.status || "").trim().toLowerCase());

export const hasAutomaticTourOptOut = (progressItems = []) => {
  const items =
    progressItems && typeof progressItems[Symbol.iterator] === "function"
      ? progressItems
      : [];
  for (const progress of items) {
    if (String(progress?.status || "").trim().toLowerCase() === "skipped") return true;
  }
  return false;
};

export const reconcileTourProgressSnapshot = (currentProgress, persistedProgress) => {
  if (isTerminalTourProgress(currentProgress) && !isTerminalTourProgress(persistedProgress)) {
    return currentProgress;
  }
  return persistedProgress;
};

export const fetchTourProgress = async () => {
  const { data } = await axios.get("/ncrm/tours/progress");
  return (Array.isArray(data?.items) ? data.items : [])
    .map(normalizeTourProgress)
    .filter((item) => item.tourKey && item.tourVersion);
};

export const saveTourProgress = async ({
  tourKey,
  tourVersion,
  action,
  currentStepKey = null,
  launchMode = "automatic",
}) => {
  const normalizedTourKey = String(tourKey || "").trim();
  const { data } = await axios.put(
    `/ncrm/tours/${encodeURIComponent(normalizedTourKey)}/progress`,
    {
      tourVersion,
      action,
      currentStepKey,
      launchMode,
    }
  );
  return normalizeTourProgress(data?.progress || {});
};
